import { DBDataTypes } from "@/config/AppConfig";
import { __localesModel, __localizedField } from "@/Utils/locales";
export const models = {
  locales: __localesModel,
  media: [],
  serviceable_id: 1,
  serviceable_type: DBDataTypes.hotel
};
export const options = {};

export const Fields = [
  __localizedField,
  {
    label: "Logo",
    name: "media",
    placeholder: "Choose image",
    type: "file",
    multiple: false,
    value: "",
    bodyClasses: "single-image",
    validationMessage: {
      required: "This field is required"
    },
    xl: "12"
  }
];
